import { Flex, Icon, Text } from '@chakra-ui/react';
import Autorenew from '@mui/icons-material/Autorenew';

export const AnalyzingChip = () => (
  <Flex
    align="center"
    bg="white"
    borderRadius="4px"
    gap="8px"
    h="36px"
    maxW="170px"
    px="8px"
    py="8px"
  >
    <Icon
      as={Autorenew}
      color="#0941a8"
      boxSize="20px"
      flexShrink={0}
      sx={{
        animation: 'spin 1s linear infinite',
        '@keyframes spin': {
          from: { transform: 'rotate(0deg)' },
          to: { transform: 'rotate(360deg)' },
        },
      }}
    />
    <Text
      color="#0941a8"
      fontSize="10px"
      fontWeight={500}
      lineHeight="12px"
      noOfLines={1}
    >
      Menganalisa bukti transfer
    </Text>
  </Flex>
);
